module.exports = __webpack_public_path__ + "static/media/window-maximize.fe863e86.svg";